import './ArtistCardType2.css';
import { FaRegHeart } from "react-icons/fa";
import { HiOutlineUserAdd } from "react-icons/hi";
import { FaUserCheck } from "react-icons/fa6";
import { API_BASE_URL } from '../../utils';

export default function ArtistCardType2({ number, data }) {
    const url = `${API_BASE_URL}/master/assets/uploads/`;

    console.log("key", number);

    return (
        <div className="artist-card-type2">
            <div className='TrendingArtistCard-wrapper'>
                <div className='TrendingArtistCard-image'>
                    <img src={url + data.profile_pic} alt={data.name} />
                    <div className='TrendingArtistCard-overlay'>
                        <span><FaRegHeart /></span>
                        <span><HiOutlineUserAdd /></span>
                        <span><FaUserCheck /></span>
                    </div>
                </div>
                <h2>{data.name}</h2>
            </div>
            <div className='artist-card-type2-bottom'>
                <h1>{number}</h1>
            </div>
        </div>
    );
}
